import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { Button } from '../ui/Button';
import { Badge } from '../ui/Badge';
interface CtaConfig {
  label: string;
  to?: string;
  href?: string;
  newTab?: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
}
interface PageHeaderProps {
  eyebrow: string;
  eyebrowClass?: string;
  title: string;
  subtitle: string;
  primaryCta?: CtaConfig;
  secondaryCta?: CtaConfig;
}
export const PageHeader = ({
  eyebrow,
  eyebrowClass = 'bg-zano-blush text-zano-pink border border-zano-pink/30',
  title,
  subtitle,
  primaryCta,
  secondaryCta
}: PageHeaderProps) => {
  return <section className="relative pt-32 pb-16 lg:pt-40 lg:pb-20 overflow-hidden" data-id="element-1342">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[420px] bg-zano-lavender/40 rounded-full blur-3xl -z-10" data-id="element-1343" />
      <div className="absolute top-24 right-0 w-[420px] h-[420px] bg-zano-blush/50 rounded-full blur-3xl -z-10" data-id="element-1344" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-1345">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-1346">
          <Badge className={`mb-6 ${eyebrowClass}`} data-id="element-1347">{eyebrow}</Badge>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-zano-charcoal mb-6 leading-[1.1]" data-id="element-1348">
            {title}
          </h1>
          <p className="text-lg md:text-xl text-gray-600 max-w-2xl mx-auto leading-relaxed" data-id="element-1349">
            {subtitle}
          </p>
          {(primaryCta || secondaryCta) && <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-1350">
              {/* Secondary on the left */}
              {secondaryCta && (secondaryCta.href ? <a href={secondaryCta.href} target={secondaryCta.newTab ? '_blank' : undefined} rel={secondaryCta.newTab ? 'noopener noreferrer' : undefined} className="w-full sm:w-auto" data-id="element-1351">
                    <Button variant="secondary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1352">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </a> : secondaryCta.to ? <Link to={secondaryCta.to} className="w-full sm:w-auto" data-id="element-1353">
                    <Button variant="secondary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1354">
                      {secondaryCta.icon}
                      {secondaryCta.label}
                    </Button>
                  </Link> : <Button variant="secondary" onClick={secondaryCta.onClick} className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1355">
                    {secondaryCta.icon}
                    {secondaryCta.label}
                  </Button>)}
              {/* Primary on the right */}
              {primaryCta && (primaryCta.to ? <Link to={primaryCta.to} className="w-full sm:w-auto" data-id="element-1356">
                    <Button variant="primary" className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1357">
                      {primaryCta.label}{' '}
                      <ArrowRight size={18} className="ml-1.5" data-id="element-1358" />
                    </Button>
                  </Link> : <Button variant="primary" onClick={primaryCta.onClick} className="w-full sm:w-auto text-base px-8 py-3.5" data-id="element-1359">
                    {primaryCta.label}{' '}
                    <ArrowRight size={18} className="ml-1.5" data-id="element-1360" />
                  </Button>)}
            </div>}
        </motion.div>
      </div>
    </section>;
};